import { Popover as BasePopover } from '@base-ui/react/popover';
import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';
import { anchoredPopupMotion } from '../lib/motion';

/** My Lab 공용 미리보기 패널·필터 등 "흐름을 끊지 않는" UI(P4)에 쓰인다. */
export const PopoverRoot = BasePopover.Root;
export const PopoverTrigger = BasePopover.Trigger;
export const PopoverClose = BasePopover.Close;

export function PopoverPopup({ className, ...props }: ComponentProps<typeof BasePopover.Popup>) {
  return (
    <BasePopover.Popup
      className={cn(
        'border-line bg-surface-raised shadow-pop p-card w-[min(90vw,22rem)] rounded-xl border',
        anchoredPopupMotion,
        className,
      )}
      {...props}
    />
  );
}

export interface PopoverContentProps extends ComponentProps<typeof BasePopover.Popup> {
  sideOffset?: number;
}

export function PopoverContent({ sideOffset = 8, children, ...props }: PopoverContentProps) {
  return (
    <BasePopover.Portal>
      <BasePopover.Positioner sideOffset={sideOffset} className="z-popover">
        <PopoverPopup {...props}>{children}</PopoverPopup>
      </BasePopover.Positioner>
    </BasePopover.Portal>
  );
}

export const Popover = {
  Root: PopoverRoot,
  Trigger: PopoverTrigger,
  Close: PopoverClose,
  Content: PopoverContent,
  Popup: PopoverPopup,
};
